/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { Button } from 'reactstrap';

const styles = css`
  font-size: 90px;
`;

const buttonStyles = css`
  position: relative;
  top: -50px;
`;

const emojiStyles = css`
  animation: Emoji-Animate2 infinite 3s linear;

  @keyframes Emoji-Animate2 {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

interface WinComponentProps {
  restart: () => void;
}

export const WinComponent = (props: WinComponentProps) => {
  return (
    <div css={styles} >
      <div css={emojiStyles}>&#128512; &#128540;</div>
      <p>Congratulations!!!</p>
      <Button css={buttonStyles} onClick={props.restart}>Play Again</Button>
      <div css={emojiStyles}>&#128526; &#129321;</div>
    </div>
  );
};
